module.exports = __webpack_public_path__ + "images/637ea7560a1a2f01dfdfbbf428ed6272.svg";